// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"styles_cardsContainer__2QLsW","cards":"styles_cards__1DRS_"};